import { Box, Chip, Grid, Button, Typography } from '@mui/material'
import React from 'react'
// import status from "./Trainingstatus.json"
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

export default function EmployeeAccessTrainingGrid() {

  const rows = [
    {
      "process": "In process",
      "lastWatch": "12/2/1998",
      "Exp": "12/02/2023",
      "renewal": "No",
      "name": "Atkinson Site Specific Training",
      "color": "#5925DC",
      "prevpass": "-",
      "history": "false",
      "client": "Green plains"
    },
    {
      "process": "Passed",
      "lastWatch": "12/2/1998",
      "Exp": "12/02/2023",
      "renewal": "No",
      "name": "Corporate Safety Training",
      "color": "#12B76A",
      "prevpass": "-",
      "history": "true",
      "client": "Green plains"


    },
    {
      "process": "In process",
      "lastWatch": "12/2/1998",
      "Exp": "12/02/2023",
      "renewal": "No",
      "name": " Safety ",
      "color": "#5925DC",
      "prevpass": "-",
      "history": "false",
      "client": "Green plains"
    },
    {
      "process": "In process",
      "lastWatch": "12/2/1998",
      "Exp": "12/02/2023",
      "renewal": "No",
      "name": " Safety ",
      "color": "#5925DC",
      "prevpass": "-",
      "history": "false",
      "client": "Green plains"
    },
    {
      "process": "In process",
      "lastWatch": "12/2/1998",
      "Exp": "12/02/2023",
      "renewal": "No",
      "name": " Safety ",
      "color": "#5925DC",
      "prevpass": "-",
      "history": "false",
      "client": "Green plains"
    },
    {
      "process": "In process",
      "lastWatch": "12/2/1998",
      "Exp": "12/02/2023",
      "renewal": "Yes",
      "name": " Orientation ",
      "color": "#5925DC",
      "prevpass": "-",
      "history": "false",
      "client": "Ormat Technologies, Inc."
    },
    {
      "process": "In process",
      "lastWatch": "12/2/1998",
      "Exp": "12/02/2023",
      "renewal": "Yes",
      "name": " Orientation ",
      "color": "#5925DC",
      "prevpass": "-",
      "history": "false",
      "client": "Ormat Technologies, Inc."
    },
    {
      "process": "In process",
      "lastWatch": "12/2/1998",
      "Exp": "12/02/2023",
      "renewal": "Yes",
      "name": " Orientation2222 ",
      "color": "#5925DC",
      "prevpass": "-",
      "history": "false",
      "client": "AGCO / GSI"
    },
    {
      "process": "passed",
      "lastWatch": "12/2/1998",
      "Exp": "12/02/2023",
      "renewal": "Yes",
      "name": " Orientation ",
      "color": "#12B76A",
      "prevpass": "-",
      "history": "true",
      "client": "AGCO / GSI"
    },
    {
      "process": "passed",
      "lastWatch": "12/2/1998",
      "Exp": "12/02/2023",
      "renewal": "Yes",
      "name": " Orientation11 ",
      "color": "#12B76A",
      "prevpass": "-",
      "history": "true",
      "client": "AGCO / GSI"
    },
    {
      "process": "passed",
      "lastWatch": "12/2/1998",
      "Exp": "12/02/2023",
      "renewal": "Yes",
      "name": " AGCO-Hesston Safety Orientation ",
      "color": "#12B76A",
      "prevpass": "-",
      "history": "true",
      "client": "AGCO / GSI"
    },
  ];
  const col = rows.map((r) => (r.process))
  // const Status = status.find((r) => r.key === col);
  // console.log(Status);
  const groupByCategory = Object.entries(rows.reduce((group, product) => {
    const { client } = product;
    group[client] = group[client] ?? [];
    group[client].push(product);
    return group;

  }, {}));
  console.log(groupByCategory);
  return (
    <>
      {groupByCategory.map((r, index) => (
        <>
          <Box key={index}>
            <div style={{ marginTop: "20px", marginBottom: "5px" }}>
              <Typography variant="h6" gutterBottom component="div" sx={{ marginLeft: "15px", marginTop: "5px", color: "#3E4A62" }}>
                {r[0]}
              </Typography>
            </div>

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
              {r[1].map((r, index) => (
                <Grid item xs={12} sm={4} md={3} key={index}>
                  <Box border={1}
                    borderLeft={1}
                    borderRight={1}
                    borderColor="#e4e7ec" sx={{ backgroundColor: "#fff", padding: "15px", width: "311px", height: "234px" }}>
                    <Chip
                      color="primary"
                      label={r.process}
                      sx={{
                        borderRadius: "3px",
                        backgroundColor: r.color,
                        color: "#FFFFFF",
                        width: "90px",
                        height: "24px",
                      }}
                    />
                    <div style={{ float: "right" }} hidden={r.process != "In process"}>
                      <PlayArrowOutlinedIcon sx={{ color: "#98A2B3" }} /></div>

                    <p style={{ color: "#2A93DB", fontSize: "16px", marginBottom: "0rem", marginTop: "10px" }}>{r.name}</p>

                    <span style={{ fontSize: "14px", }} > <span style={{ color: "#667085", fontSize: "14px", marginTop: "20px" }}>Last Watched:</span>
                      {r.lastWatch} </span>
                    <br />
                    <span style={{ fontSize: "14px", marginTop: "20px" }}> <span style={{ color: "#667085", fontSize: "14px", marginTop: "20px" }}>Expiration Date:</span>
                      {r.Exp} </span>
                    <br />
                    <span style={{ fontSize: "14px", marginTop: "20px" }}> <span style={{ color: "#667085", fontSize: "14px", marginTop: "10px" }}>Is it a renewal:</span>
                      {r.renewal} </span>
                    <br />
                    <Box hidden={r.history == "false"}>
                      <Button

                        style={{ color: "#2A93DB", cursor: "pointer" }}
                      >
                        <InsertDriveFileOutlinedIcon
                          sx={{

                            color: "#2A93DB",
                            cursor: "pointer",
                          }}
                        />
                        Training Certificate
                      </Button>
                      <br />
                      <Button sx={{ color: "#2A93DB" }}>
                        <InsertDriveFileOutlinedIcon
                          sx={{ color: "#2A93DB" }}
                        />
                        Download Document
                      </Button>

                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </>
      ))}
    </>
  )

}
